import { Badge } from '@/components/ui/badge'
import type { PortalPersonStatus } from './portalPeople.types'

export function FormerBadge() {
  return (
    <Badge variant="neutral" className="ml-1.5">
      Former
    </Badge>
  )
}

export function PortalPersonName({
  name,
  status,
  badge = true,
}: {
  name: string | null
  status: PortalPersonStatus
  badge?: boolean
}) {
  if (status === 'erased' || name === null)
    return <span className="text-muted-foreground">Erased contact</span>
  return (
    <span>
      {name}
      {badge && status === 'former' && <FormerBadge />}
    </span>
  )
}
